module.exports = __webpack_public_path__ + "static/media/thematic1.e5fba81d.jpg";